import { useId, useState } from 'react';
import { Button, Card, CardContent, CardDescription, CardHeader, CardTitle } from '@xxtract/ui';
import { useTranslation } from 'react-i18next';

interface DisabledEnrollmentActionProps {
  label: string;
}

export function DisabledEnrollmentAction({ label }: DisabledEnrollmentActionProps) {
  const { t } = useTranslation();
  const [isHelpOpen, setIsHelpOpen] = useState(false);
  const descriptionId = useId();

  return (
    <div className="flex flex-wrap items-center gap-2">
      <Button aria-describedby={isHelpOpen ? descriptionId : undefined} className="min-h-11" disabled>
        {label}
      </Button>
      <Button
        aria-controls={descriptionId}
        aria-expanded={isHelpOpen}
        className="min-h-11"
        onClick={() => setIsHelpOpen((isOpen) => !isOpen)}
        variant="ghost"
      >
        {t('dashboard.enrollment.showUnavailableHelp')}
      </Button>
      {isHelpOpen && (
        <p className="basis-full text-sm text-[var(--foreground-muted)]" id={descriptionId} role="status">
          {t('dashboard.enrollment.unavailableExplanation')}
        </p>
      )}
    </div>
  );
}

export function EnrollmentStrip() {
  const { t } = useTranslation();

  return (
    <Card data-testid="enrollment-strip">
      <CardHeader>
        <CardTitle>{t('dashboard.enrollment.title')}</CardTitle>
        <CardDescription>{t('dashboard.enrollment.emptyDescription')}</CardDescription>
      </CardHeader>
      <CardContent className="flex flex-wrap items-center justify-between gap-4">
        <p className="text-sm text-[var(--foreground-muted)]">{t('dashboard.enrollment.emptyHint')}</p>
        <DisabledEnrollmentAction label={t('dashboard.enrollment.startFirst')} />
      </CardContent>
    </Card>
  );
}
